export default __webpack_public_path__ + "static/media/testimony_teacher_two.8d5a8a36.png";